import { ActivityStatusOption, IncludeExclude } from "../../../utils/types";
import Autocomplete from "../../library/Autocomplete";
import ACTIVITY_STATUS_OPTIONS from "./activityStatusOptions";

interface ActivityStatusAutocompleteProps {
  onChange: (selected: ActivityStatusOption[]) => void;
  selected: ActivityStatusOption[];
  reactRef?: any;
  disabled?: boolean;
  multiple?: boolean;
  style?: {[key:string]:string};
  useIncludeExclude?: boolean;
  defaultIncludeExclude?: IncludeExclude;
  includeExcludeOnChange?: (newIncludeExclude:IncludeExclude) => void;
  options?: ActivityStatusOption[]; // Allow custom options, fallback to default
}

function ActivityStatusAutocomplete(props: ActivityStatusAutocompleteProps) {
  const labelKeyFunction = (option: ActivityStatusOption) => {
    return option.name;
  }

  return (
    <Autocomplete
      id="activityStatusAutocomplete"
      placeholder="Recent Activity"
      reactKey="activityStatusAutocomplete"
      labelKey={labelKeyFunction}
      onChange={props.onChange}
      options={props.options || ACTIVITY_STATUS_OPTIONS}
      selected={props.selected}
      reactRef={props.reactRef}
      disabled={props.disabled}
      useIncludeExclude={props.useIncludeExclude}
      defaultIncludeExclude={props.defaultIncludeExclude}
      includeExcludeOnChange={props.includeExcludeOnChange}
      multiple={props.multiple}
      style={props.style}
      paginate={false}
      maxResults={ACTIVITY_STATUS_OPTIONS.length + 1}
      keepDropdownOpen={true}
    />
  );
}

export default ActivityStatusAutocomplete;